/**
 * Tile de una foto en el detalle de una tarea del cliente (`/tareas-cliente`).
 *
 * Es una GRILLA de cuadrados de ~120 px: pinta la miniatura webp de 400 px
 * (`thumbUrl`) y solo al tocar la foto se descarga la versión completa
 * (`preview.src` de AntD Image, dentro del `Image.PreviewGroup` del padre).
 * Si la entrada no trae miniatura (`thumbUrl` nulo o ausente, p. ej. archivos
 * viejos) cae a la URL completa. El botón de descarga también baja el original.
 */

import { Button, Image, Spin } from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import { urlMiniatura } from "../../../utils/miniatura";
import type { Attachment } from "../types";

export function TareaFotoTile({
  img,
  descargando,
  onDescargar,
}: {
  img: Attachment;
  descargando: boolean;
  onDescargar: () => void;
}) {
  // El admin puede dejar un comentario por foto; el cliente lo ve aquí en solo lectura
  // (ver backend/src/controllers/tasks.controller.js setAttachmentComment).
  const comentario = img.comentario;
  return (
    <div
      className="tc-gallery-item"
      data-testid="tc-foto-tile"
      title={img.name}
      style={{ position: "relative" }}
    >
      <Image
        src={urlMiniatura(img)}
        preview={{ src: img.url }}
        alt={img.name}
        width="100%"
        height="100%"
        rootClassName="tc-gallery-img-root"
        style={{ objectFit: "cover" }}
        placeholder={
          <div className="tc-gallery-ph">
            <Spin size="small" />
          </div>
        }
      />
      <Button
        size="small"
        shape="circle"
        icon={<DownloadOutlined />}
        loading={descargando}
        data-testid="tc-foto-descargar"
        onClick={(e) => {
          e.stopPropagation();
          onDescargar();
        }}
        style={{
          position: "absolute",
          top: 6,
          right: 6,
          zIndex: 5,
          background: "rgba(255,255,255,0.85)",
        }}
      />
      {comentario ? (
        <div
          style={{
            position: "absolute",
            left: 0,
            right: 0,
            bottom: 0,
            background: "linear-gradient(to top, rgba(0,0,0,0.78), rgba(0,0,0,0))",
            color: "#fff",
            padding: "16px 10px 8px",
            fontSize: 12,
            lineHeight: 1.35,
            whiteSpace: "pre-wrap",
            pointerEvents: "none",
          }}
        >
          {comentario}
        </div>
      ) : null}
    </div>
  );
}
